import React from 'react';
import { Bubble } from 'tea-component';
import "./index.scss";
import { useIntl } from 'umi';
import { getTranslatedText } from '../../utils/getTranslatedText';

interface MetricsCardSubTitleProps {
  tipsEn?: string;
  tipsCn?: string;
  titleEn: string;
  titleCn: string;
  className?: string;
  style?: React.CSSProperties;
}

const MetricsCardSubTitle: React.FC<MetricsCardSubTitleProps> = (props) => {
  const { locale } = useIntl();
  const { tipsEn = '', tipsCn = '', titleEn, titleCn, className = '', style = {} } = props;

  // 注释
  const tips = getTranslatedText(tipsEn, tipsCn, locale);
  // 标题/副标题中英文翻译
  const title = getTranslatedText(titleEn, titleCn, locale);

  return (
    <Bubble dark placement="top" content={tips ? <div className='overlay-card-desc' dangerouslySetInnerHTML={{ __html: tips }}></div> : null}>
      <div className={`dbd-metrics-card-subtitle__text ${className}`} style={style}>
        {title}
      </div>
    </Bubble>
  );
};

export default MetricsCardSubTitle;
